import { get, uniq } from 'lodash';
import { useCreativeCampaignData } from '../../hooks/useCreativeCampaignData';

export const useOsFamilyCampaign = () => {
    const { fetchedCampaign } = useCreativeCampaignData();
    const allValues = get(fetchedCampaign, 'campaignTargeting.osTargeting.values', []);
    return uniq(allValues.map(el => el.osFamily));
};
